import { Cookies } from 'react-cookie';

import { TrapActivationHistoryMonitoring } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getHistoryMonitoring = async (slug: string, type: string, startDate?: string, endDate?: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/trap_hourly_signals/${type}/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      startDate,
      endDate,
    },
  });
  return data.data as TrapActivationHistoryMonitoring[];
};
